import classNames from 'classnames'

import { Skeleton } from '@src/quince-components/src'

import styles from './CollectionFilters.module.scss'

const FILTER_SKELETON_COUNT = 5

const CollectionFilterLoader = ({ containerClassName }: { containerClassName?: string }) => {
  return (
    <div className={classNames(styles.filterSectionLoader, containerClassName)}>
      <div className={styles.filterSectionLoaderSkeletonContainer}>
        {new Array(FILTER_SKELETON_COUNT).fill(0).map((_, index) => (
          <Skeleton key={index} className={styles.filterSectionLoaderSkeleton} />
        ))}
      </div>
      <Skeleton className={styles.filterSectionSortByLoaderSkeleton} />
    </div>
  )
}

export default CollectionFilterLoader
